<template>
  <v-alert
      :id="`${ report['unique_guid'] }`"
      :style="`color: ${ CheckReport(report) ? 'default' : 'red' }`"
      class="ma-1 pa-0"
      border-color="red">
    <template v-slot:default>
      <div class="d-flex">
        <p>{{ report['report_description'] }}</p>
        <span v-if="CheckObject(report)">&nbsp;{{ report.report_data.length > 0 && report.report_data[0] && Object.keys(report.report_data[0]).includes('ФизОбъектПРЕДСТАВЛЕНИЕ') ? report.report_data[0]['ФизОбъектПРЕДСТАВЛЕНИЕ'] : null }}</span>
        <v-spacer />
        <v-btn v-if="report['watched']" :icon="['fas', 'check']" density="compact" variant="text">
          <v-icon :icon="['fas', 'check']" />
        </v-btn>
        <v-tooltip>
          <template v-slot:default>
            <span v-if="!report['description_note']">Пояснительная записка отсутствует!</span>
            <span v-else>Пояснительная записка присутствует!</span>
          </template>
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" :icon="['fas', 'file-lines']" :style="report['description_note'] ? 'color: #70b225' : 'color: #e4e4e4'" density="compact" variant="text">
              <v-icon :icon="['fas', 'file-lines']" />
            </v-btn>
          </template>
        </v-tooltip>
        <v-btn v-on:click="delete_report()" :icon="['fas', 'trash']" density="compact" variant="text">
          <v-icon :icon="['fas', 'trash']" />
        </v-btn>
        <v-btn disabled :icon="['fas', report_space.toString()]" density="compact" variant="tonal">
          <v-icon :icon="['fas', report_space.toString()]" />
        </v-btn>
      </div>
    </template>
  </v-alert>
</template>

<script>
import { CurrentData, CurrentDialog } from "@/store/report/CurrentDialogData"
import { ReportData } from "@/store/report/ReportData"
import {CheckReport} from "@/libs/report_checker";

export default {
  name: "EditorElement",
  props: ['report', 'group_id', 'section_guid'],
  computed: {
    report_space() {
      let chart_cfg = this.$rep_cfg.charts.find(el => el.guid === this.report['report_guid'])
      return chart_cfg.needSpace
    },
    current: {
      get() {
        return CurrentData().get()
      },
      set(value) {
        CurrentData().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    },
    dialog: {
      get() {
        return CurrentDialog().get()
      },
      set(value) {
        CurrentDialog().set(value)
      }
    }
  },
  methods: {
    CheckReport,
    CheckObject: function (element) {
      const chart = this.$rep_cfg.charts.find(el => el.guid === element['report_guid'])
      if (chart && chart.has_objects) return true
      return false
    },
    delete_report: function () {
      let section = this.report_data.section_list.find(section => section.guid === this.section_guid)
      let page = section.groups.find(group => group.guid === this.group_id)
      page.reports.splice(page.reports.indexOf(page.reports.find(report => report.unique_guid === this.report.unique_guid)), 1)

      this.report_data['unused'].push(this.report)
    },
    editCard: function () {
      this.current = this.report
      this.dialog = true
    }
  }
}
</script>

<style scoped>

</style>
